import _isFinite from 'lodash/isFinite';
import { sanitizeSummableValue } from './structured-data-utilities';
import { EMPTY_VALUE } from './constants';

export const isNumericValue = (candidate) => {
  const floatValue = parseFloat(candidate);
  return _isFinite(floatValue);
};

export const sumIfNumber = (augend, addend) => {
  if (augend === EMPTY_VALUE) {
    return addend;
  }

  if (!isNumericValue(addend)) {
    return augend;
  }

  return sanitizeSummableValue(augend) + sanitizeSummableValue(addend);
};
